/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetUniverseRegionsRegionIdNotFound
 */
export interface GetUniverseRegionsRegionIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetUniverseRegionsRegionIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetUniverseRegionsRegionIdNotFound interface.
 */
export function instanceOfGetUniverseRegionsRegionIdNotFound(value: object): value is GetUniverseRegionsRegionIdNotFound {
    return true;
}

export function GetUniverseRegionsRegionIdNotFoundFromJSON(json: any): GetUniverseRegionsRegionIdNotFound {
    return GetUniverseRegionsRegionIdNotFoundFromJSONTyped(json, false);
}

export function GetUniverseRegionsRegionIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseRegionsRegionIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetUniverseRegionsRegionIdNotFoundToJSON(json: any): GetUniverseRegionsRegionIdNotFound {
    return GetUniverseRegionsRegionIdNotFoundToJSONTyped(json, false);
}

export function GetUniverseRegionsRegionIdNotFoundToJSONTyped(value?: GetUniverseRegionsRegionIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

